<template>
    <div>
        <div class="col-12 lg:col-12 px-0">
        <Toolbar class="mb-2">
            <template #end>
            <Button
                label="Nuevo"
                icon="pi pi-plus"
                class="p-button-success mr-2"
                @click="agregarMedio"
            />
            </template>
        </Toolbar>
        </div>

        <DataTable
        :value="lstMedios"
        dataKey="Id_tipo_medio"
        ref="dt"
        v-model:filters="filters"
        :globalFilterFields="['Descripcion']"
        :loading="loading"
        :paginator="true"
        :rows="20"
        responsiveLayout="scroll"
        >
        <template #header>
            <div class="table-header">
            <h5>Tipos de medios</h5>
            <span>Número de medios {{ lstMedios ? lstMedios.length : 0 }}</span>
            <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                type="text"
                v-model="filters['global'].value"
                placeholder="Buscar..."
                />
            </span>
            </div>
        </template>
        <template #empty> No se encontrarón registros. </template>
        <template #loading> Cargando datos. Espere por favor. </template>
        <Column field="Descripcion" header="SERVCIO" sortable>
            <template #body="{data}"> {{ data.Descripcion }}</template>
        </Column>
        <Column field="Activo" header="ESTATUS" sortable>
            <template #body="slotProps">
            <span class="status-activo" v-show="slotProps.data.Estatus == true"> ACTIVO </span>
            <span class="status-inactivo" v-show="slotProps.data.Estatus == false"> INACTIVO </span>
            </template>
        </Column>
        <Column :exportable="false">
            <template #body="slotProps">
            <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success"
                @click="edit(slotProps.data)"
            />
            <Button
                style="margin-left: 8px"
                icon="pi pi-times"
                class="p-button-rounded p-button-danger"
                @click="borrar(slotProps.data)"
            />
            </template>
        </Column>
        <template #footer>
            Registros en total {{ lstMedios ? lstMedios.length : 0 }}
        </template>
        </DataTable>

        <Dialog :style="{ width: '600px' }" :visible="showAgregar" :modal="true" class="p-fluid" :closable="false">
            <template #header>
                <h3>{{ modoEdicion }} medio</h3>
            </template>

            <div class="p-formgrid grid">
                <div class="p-field col">
                <label for="Medio">Medio</label>
                <InputText
                    autocomplete="off"
                    id="Producto"
                    v-model.trim="medio.Descripcion"
                    required="true"
                    autofocus
                    :class="{ 'p-invalid': submitted && !medio.Descripcion }"
                />
                <small class="p-invalid" v-if="submitted && !medio.Descripcion">El medio es requerido.</small>
                </div>
            </div>

            <div class="p-formgrid grid">
                <div class="p-field col">
                <div class="p-field-checkbox">
                    <Checkbox
                    id="Activo"
                    name="Activo"
                    :binary="true"
                    v-model="medio.Activo"
                    />
                    <label for="Activo"> Activo</label>
                </div>
                </div>
            </div>

            <template #footer>
                <Button
                label="Cancelar"
                icon="pi pi-times"
                class="p-button-text"
                @click="cancelarDialogo"
                />
                <Button
                label="Guardar"
                icon="pi pi-check"
                class="p-button-text"
                id="btnGuardar"
                @click="guardarMedio"
                />
            </template>
        </Dialog>
        <ConfirmDialog></ConfirmDialog>
    </div>
</template>
  
<script>
import SCatalogos from "../service/Tipos_medios";
import { FilterMatchMode } from "primevue/api";
import { ConfirmDialog } from 'primevue/confirmdialog';
import {mapGetters} from 'vuex';

export default {
    components: {
        ConfirmDialog
    },
    data() {
        return {
            Activo: false,
            Capitalizable: false,
            Salida_individual: false,
            lstUnidades: [],
            selectedUnidadFiltro: null,
            lstMedios: null,
            lstMediosO: null,
            lstTipos: null,
            lstModalidades: null,
            filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            },
            filter: null,
            loading: true,
            submitted: false,
            showAgregar: false,
            dispositivoEdited: null,
            modoEdicion: "",
            medio: {},
            img: "",
            mensajes:"",
            usuario: {},
            lstEstatus: [],
        };
    },
    created() {
        this.getMedios();
    },
    methods: {
        getMedios() {
            var t = this;
            var CSrvr = new SCatalogos();
            t.loading = true;

            CSrvr.getMedios(t)
                .then((res) => {
                    t.lstMedios = res;
                    t.loading = false;
                })
                .catch(function (error) {
                    console.error("Error:", error);
                    t.loading = false;
                });
        },
        collapseAll() {
            this.expandedRows = null;
        },
        forzarUpdate() {
            this.$forceUpdate();
        },
        agregarMedio() {
            var t = this;
            t.loading = true;

            this.submitted = false;
            this.showAgregar = true;
            this.modoEdicion = "Agregar";
            this.mensajes = "";
            this.medio.Activo = false;
        },
        cancelarDialogo() {
            this.submitted = false;
            this.showAgregar = false;
            this.modoEdicion = "";
            this.medio = {};
            this.mensajes = "";
        },
        edit(obj) {
            var t = this;
            t.loading = true;

            this.medio = { ...obj };
            this.showAgregar = true;
            this.modoEdicion = "Editar";
            if(obj.Estatus == true){
                this.medio.Activo = true;
            }
        },
        borrar(obj) {
            var t = this;      
            t.$confirm.require({
                message: '¿Quiere desactivar el medio?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: 'Sí, eliminar',
                rejectLabel: 'Cancelar',
                acceptClass: 'p-button-danger',
                accept: () => {
                    var val = obj;
                    var ctlSvr = new SCatalogos();

                    t.loading = false;

                    obj.Activo = false;
                    obj.Estatus = false;
                    
                    ctlSvr.updateMedio(t, val).then(() => {
                        t.$toast.add({
                            severity: "success",
                            summary: "AVISO",
                            detail: "Insumo eliminado correctamente",
                            life: 3000,
                        });
                        t.getMedios();
                    });
                },
                reject: () => {
                    // Acción al rechazar
                }
            });
        },
        guardarMedio() {
            var t = this;
            this.submitted = true;

            if (!t.medio || !t.medio.Descripcion) {
                t.mensajes = "Algunos campos faltantes son obligatorios";
                return;
            }

            if (t.medio.Activo == false) {
                t.medio.Estatus = false;
            } else {
                t.medio.Estatus = true;
            }

            this.sendRequest(t, t.medio);
        },
        sendRequest(t, obj) {
            var CSrvr = new SCatalogos();
            if (t.modoEdicion == "Agregar") {
                CSrvr.addMedio(t, obj).then(() => {
                    t.$toast.add({
                        severity: "success",
                        summary: "AVISO",
                        detail: "Insumo agregado correctamente",
                        life: 3000,
                    });
                    t.cancelarDialogo();
                    t.getMedios();
                });
            } else {
                if (obj.Activo == false) {
                    CSrvr.updateMedio(t, obj).then(() => {
                        t.$toast.add({
                            severity: "success",
                            summary: "AVISO",
                            detail: "Insumo editado correctamente",
                            life: 3000,
                        });
                        t.cancelarDialogo();
                        t.getMedios();
                    });
                } else{
                    CSrvr.updateMedio(t, obj).then(() => {
                        t.$toast.add({
                            severity: "success",
                            summary: "AVISO",
                            detail: "Insumo editado correctamente",
                            life: 3000,
                        });
                        t.cancelarDialogo();
                        t.getMedios();
                    });
                }
            }
        }
    },
    computed: {
        ...mapGetters(['getUrlMedios','getUsuarioLogueado']),  
    }       
};
</script>
  
<style scoped>
.table-header {
display: flex;
justify-content: space-between;
-webkit-box-pack: justify;
}
.title {
font-weight: 700;
letter-spacing: 0.3px;
margin-right: 10px;
text-transform: uppercase;
}
.data {
letter-spacing: 0.3px;
margin-right: 10px;
letter-spacing: 0.5px;
}
.product-image {
width: 100px;
}
</style>
  